import { useLogin } from './useLogin';
import { useLogout } from './useLogout';
import { useMe } from './useMe';

export function useAuth() {
  const meQuery = useMe();
  const loginMutation = useLogin();
  const logoutMutation = useLogout();

  return {
    user: meQuery.data ?? null,
    isAuthenticated: !!meQuery.data,
    isLoading: meQuery.isLoading,
    login: loginMutation.mutateAsync,
    isLoggingIn: loginMutation.isPending,
    loginError: loginMutation.error,
    logout: logoutMutation.mutate,
    isLoggingOut: logoutMutation.isPending,
  };
}
